// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductCondensedStyles } from "@vanmeter/Overrides/Components/ProductCarouselProductCondensed";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.productWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 4px;
        width: 122px;
        padding: 4px;
        border: 1px solid ${color("common.border")};
        :hover {
            border: 1px solid ${color("primary")};
        }
    `,
};

productCarouselProductCondensedStyles.actionWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

productCarouselProductCondensedStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            height: 112px;
        `,
    },
    img: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
        `,
    },
};
